import { FileType } from './types';
/**
 * 获取文件类型
 *
 * @export
 * @param {(File | string | Blob)} file 文件
 * @return {*}  {FileType}
 */

export function getFileType(file) {
  if (typeof file === 'string') {
    return FileType.TEXT;
  }

  var mimeType = file.type;

  var _mimeType$split = mimeType.split('/'),
      type = _mimeType$split[0],
      subType = _mimeType$split[1];

  if (type === 'image') {
    return FileType.IMAGE;
  }

  if (type === 'video' || mimeType === 'application/ogg') {
    return FileType.VIDEO;
  }

  if (type === 'audio') {
    return FileType.AUDIO;
  }

  if (subType === 'pdf') {
    return FileType.PDF;
  }

  if (subType === 'msword' || subType === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return FileType.WORD;
  }

  if (subType === 'vnd.ms-powerpoint' || subType === 'vnd.openxmlformats-officedocument.presentationml.presentation') {
    return FileType.PPT;
  }

  if (subType === 'vnd.ms-excel' || subType === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return FileType.EXCEL;
  }

  return FileType.UNKNOWN;
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/helpers.js
// module id = 591
// module chunks = 6